import { Component, Input, Inject, ChangeDetectorRef, PLATFORM_ID, Renderer2, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, PlatformLocation, Location } from '@angular/common';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { StateInteractionService } from 'angular-engine/engine/service/dynamic/state.interaction.service';
import { UtilService } from 'angular-engine/engine/service/util/util.service';
import { DataService } from "angular-engine/engine/service/data/api.data.service";

import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { UIStateEngine } from 'angular-engine/engine/service/ui/ui.state.engine';
import { UIAppHelper } from 'angular-engine/engine/service/ui/ui.app.helper';
import { MetaService } from 'angular-engine/engine/service/meta/meta.service';
import { StaticContainer } from "./static-container.component";
import { ScrollingHelperService } from 'angular-engine/engine/service/ui/scrolling/scrolling.helper.service';
import { Angulartics2Vdgm } from 'angular-engine/engine/providers/Angulartics2Vdgm';

@Component({
  selector: 'interactive-container',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InteractiveContainer extends StaticContainer {
  protected subscriptions: Array<any> = []
  @Input() isActive: boolean = false;
  @Input() focusedItemIndex: number = -1;
  @Input() interactionBack: boolean;
  //private monitoredProps = ['isActive', 'focusedItemIndex'];
  private monitoredPropsMap = {
    //isActive: 'isActive',
    focusedItemIndex: 'selectedItem'
  };
  protected keys = [];
  protected KeyCode: any;
  protected TraversalModes: any;
  protected focusedItem: number;
  protected wasPopped = false;
  protected rootMessage = false;
  private popSubscription: any;;
  protected slug: string;
  protected scrollElement: any;
  private offsetScrollY = 0.0;
  private pinnedUrl = "";

  constructor(
    protected coreEffects: CoreEffects,
    @Inject(PLATFORM_ID) protected platformId: string,
    protected ref: ChangeDetectorRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected metaService: MetaService,
    protected location: Location,
    @Inject(APP_SETTINGS) protected settings: any,
    protected eventInteractions: EventInteraction,
    protected uiStateEngine: UIStateEngine,
    protected renderer: Renderer2,
    protected elem: ElementRef,
    protected scrollHelper: ScrollingHelperService,
    protected analytics: Angulartics2Vdgm
  ) {
    super(coreEffects, platformId, ref, router, route, metaService, location, settings, null, null, eventInteractions);
    this.popSubscription = this.location.subscribe(ev => {
      this.wasPopped = true;
      if (!ev.url) {
        ev.url = "/home-ott";
      }
      this.coreEffects.setPopState(true, ev.url);
      this.uiStateEngine.popState(ev.url);
    });
    this.subscriptions.push(this.eventInteractions.subscribe(e => {
      if (e.key == "rootPage") {
        this.rootMessage = true;
        this.uiStateEngine.setActivePathHistory([]);
      }
    }));
    this.scrollHelper.renderer = renderer;
    this.KeyCode = this.settings.KeyCode;
    this.TraversalModes = this.settings.TraversalModes;
  }

  ngOnInit() {
    super.ngOnInit()
    this.pinnedUrl = this.router.url;
    this.subscriptions.push(this.eventInteractions.subscribe(e => {
      if (e.key == "activeInteractionChanged") {
        this.isActive = e.message === "content";
        this.ref.detectChanges();
      }
    }));

    setTimeout(() => {
      const navOpen = this.uiStateEngine.getNavState();
      if (navOpen !== undefined) {
        this.isActive = !navOpen;
        this.ref.detectChanges();
      }
    }, 250);

    this.uiStateEngine.setSupportedKeys(this);

    this.subscriptions.push(this.eventInteractions.subscribe(e => {
      if (e.key == "verticalScrollingRequested") {
        this.requestVerticalScroll(e.message);
      }
    }));

    this.uiStateEngine.registerInteractiveHandler(this);
    const currentState = this.uiStateEngine.getActivePath();
    const routeUrl = (this.router.url == "/" || this.router.url == "") ? "/home-ott" : this.router.url;
    if (!currentState || currentState.urlKey != routeUrl) {
      const stateObj = {
        urlKey: (this.router.url == "/") ? "/home-ott" : this.router.url,
        isActive: this.isActive,
        selectedItem: this.focusedItemIndex,
        offsetScrollY: 0.0,
        childrenState: {}
      }
      this.uiStateEngine.setActivePath(stateObj);
    }
    else {
      const rootChildKey = this.router.url.substr(1).replace('-ott', '');
      const rootChild = currentState;
      this.onStateRestored(currentState);
    }

    //assigns default focused index (if not available in state)
    if (this.focusedItemIndex == -1) this.focusedItemIndex = 0
  }

  ngAfterViewInit(){
      this.eventInteractions.next({ key: 'toggleSpinner', message: false });
      this.uiStateEngine.toggleInteractionSuspend(false);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.uiStateEngine.deregisterHandler(this);
    this.subscriptions.forEach(s => s.unsubscribe())
    if (this.popSubscription) {
      this.popSubscription.unsubscribe();
    }
    if (!this.wasPopped) {
      if (this.rootMessage) {
        this.uiStateEngine.setActivePathHistory([]);
        this.rootMessage = false;
      }
      else {
        this.uiStateEngine.addToHistory();
      }
    }
  }

  canProcessKey(keyCode) {
    return this.isActive && this.keys.indexOf(keyCode) > -1;
  }

  processKey(keyCode) {
    return false;
  }

  scrollVertically(elem) {
    this.requestVerticalScroll(elem);
  }

  protected addFakeHomeHistoryEntry(){
    const fakeHistory = {
      urlKey: "/home-ott",
      isActive: false,
      selectedItem: -1,
      offsetScrollY: 0,
      childrenState: {
          "home--2": { offsetScrollX: 0 }
      }
    }
    this.uiStateEngine.addToHistory(fakeHistory);
  }

  protected requestVerticalScroll(elem) {
    const yPosition = this.scrollHelper.requestVerticalScrollPosition(elem)
    if (yPosition > 0 || this.offsetScrollY > 0) {
      this.offsetScrollY = yPosition;
      this.scrollToOffset(yPosition);
      this.updateStateObject({ offsetScrollY: this.offsetScrollY, selectedItem: this.focusedItemIndex })
    }
  }

  protected scrollToOffset(yPosition) {
    let targetElem = this.scrollElement || this.elem;
    this.scrollHelper.scrollElementToOffset({ elem: targetElem, x: -1, y: yPosition });    
  }

  protected updateStateObject(obj) {
    const currentState = this.uiStateEngine.getActivePath();
    if (currentState && currentState.urlKey == this.router.url) {
      const stateObj = Object.assign({}, currentState, obj);
      this.uiStateEngine.setActivePath(stateObj);
    }
  }

  protected onStateRestored(currentState) {
    this.focusedItemIndex = currentState['selectedItem'];
    this.offsetScrollY = currentState['offsetScrollY'] || 0.0;
    if (this.offsetScrollY > 0) { this.scrollToOffset(this.offsetScrollY); }
    //implement in derived containers if needed;
  }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-component/interactive-container.component.ts